<template>
	<section class="button-create-container">
		<button
			v-if="btnFunction"
			type="button"
			class="button-create"
			style="justify-content: center !important;"
			:disabled="disabled"
			v-on:click="functionClick">
			<span class="icon">+</span>
			<span class="ml-2"> {{ text }}</span>
		</button>
		<button
			v-else
			class="button-create">
			<router-link :to="href">
				<span class="icon">+</span>
				<span> {{ text }}</span>
			</router-link>
		</button>
	</section>
</template>

<script>
function functionClick() {
	this.$emit('function-click');
}

export default {
	name: 'button-create',
	methods: {
		functionClick,
	},
	props: {
		btnFunction: {
			default: false,
			type: Boolean,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		href: {
			type: [String, Object],
			default: '/',
		},
		text: {
			type: String,
		},
	},
};
</script>


<style lang="scss" scoped>
.button-create-container {
	display: flex;
	justify-content: flex-end;

	button {
		align-items: center;
		background-color: map-get($colors, button-create);
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
		color: white;
		display: inline-flex;
		height: 40px;
		justify-content: space-around;
		width: 100%;

		a {
			color: white;
			display: block;
			height: 100%;
			text-align: center;
			width: 100%;
		}

		span {
			&.icon {
				font-size: 35px;
				height: 35px;
				margin-top: -7px
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// ButtonCreate.vue?33e4822b